import React, { useState,useEffect,useRef  } from 'react';
import { Button, Container, Row, Col, Form, InputGroup, FormControl, FormSelect } from 'react-bootstrap';
//import FloatingButton2 from './UserMenu2';
import toast, { Toaster } from 'react-hot-toast';
import {navigateTo} from './../utils/commonFunctions'

import { markdownToHtml,convertTextToHtmlWithLinks } from '../utils/commonFunctions';

import FloatingButton from './UserMenu';
import AutenticationService from '../services/Authentication.service';
import Spinner from 'react-bootstrap/Spinner';
import { adUnits } from '../constants/Constants';
import AdUnitComponent from './AdUnitComponent';
import BotResponseComponent from './BotResponseComponent';


const ChatComponent = ({messages,handleChange,noticiasHoy,mensajeInicial,loading}) => {  
  const [inputValue, setInputValue] = useState('');
  const nombreUsusario = AutenticationService.getUserName();
  const isLogged = AutenticationService.getIsLogged();
  const chatContainerRef = useRef(null);
  const [titulo,setTitulo] = useState('');

  const inputRef = useRef(null); 

  const responsive_article_leaderboard_1 = adUnits.find(adUnit => adUnit.idAdUnit = 'responsive_article_leaderboard_1');
  const responsive_article_leaderboard_2 = adUnits.find(adUnit => adUnit.idAdUnit = 'responsive_article_leaderboard_2');
  const responsive_article_vertical_1 = adUnits.find(adUnit => adUnit.idAdUnit = 'responsive_article_vertical_1');
  const responsive_article_sticky = adUnits.find(adUnit => adUnit.idAdUnit = 'responsive_article_sticky');

  const handleFocus = () => {
    inputRef.current.focus();
  };

  const notify = (text) => toast.success(text);

  const copiar = (text) => {
    navigator.clipboard.writeText(text)
    .then(() => {      
      toast.success('Texto copiado');
    })
    .catch((err) => {
      toast.error('Error al copiar');
    });
    
  } 
 

  const handleSendMessage = (e) => {    
    handleChange({texto:inputValue,isUser:true});    
    setInputValue('');
    if (inputRef.current) {      
      inputRef.current.style.height = '';
    }
  };

  const handeEditMessage = (text) => {
    if(!loading){
      setInputValue(text);
      handleFocus();
    }else{
      toast('Espera un momento...');
    }    
  }

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      const userDivs = chatContainerRef.current.querySelectorAll(".user");
      if (userDivs.length > 0) {
        userDivs[userDivs.length - 1].scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  useEffect(() => {
    scrollToBottom();

    if(messages.length>0){
      let t = messages.filter((item)=>(item.isUser)).pop().texto;      
      setTitulo(t)
    }
    else{      
      setTitulo('')
    }
    //handleFocus();
    
  }, [messages]); 

  const handleInputChange = (e) => {
    setInputValue(e.target.value);

    // Ajustar la altura del textarea
    if (inputRef.current) {      
      inputRef.current.style.height = 'auto';
      inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
    }
  };
  
  return (
    <>    
    <Container fluid className='chat-container py-3 px-4' 
      style={{
        display: 'flex', 
        flexDirection: 'column' 
      }}
    >
      <Row className="d-block d-md-none" style={{ flexShrink: 0 }}>
        <Col>          
          {messages.length>0 && (
              <div                 
                className="addUnit horizontal mobile"
                style={{                  
                  maxWidth: '320px',
                  width: '100%',
                  height: '50px',
                }}
              >
                {/*Ad 320x50*/}
                <AdUnitComponent
                  data={responsive_article_sticky.data}
                  containerId={'ad-horizontalMobile1'}
                />
              </div>
            )}
        </Col>
      </Row>
      
      <Row className="py-2" style={{ flexShrink: 0 }}>
            <Col xs={12} md={8} lg={8} xl={9} className="d-flex align-items-center text-center">
              {(messages.length>0&&<>
              <div className='text-center mx-auto'>
                <div className='d-none d-md-block ms-2'>
                  <span className="chat-title" title={titulo}>{titulo}</span>
                  <span 
                    className='btn-titulo d-none d-md-inline'
                    onClick={()=>(handeEditMessage(titulo))}
                  > 
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <mask id="mask0_351_13913" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                      <rect y="0.5" width="24" height="24" fill="#D9D9D9"/>
                      </mask>
                      <g mask="url(#mask0_351_13913)">
                      <path d="M5 19.5H6.425L16.2 9.725L14.775 8.3L5 18.075V19.5ZM4 21.5C3.71667 21.5 3.47917 21.4042 3.2875 21.2125C3.09583 21.0208 3 20.7833 3 20.5V18.075C3 17.8083 3.05 17.5542 3.15 17.3125C3.25 17.0708 3.39167 16.8583 3.575 16.675L16.2 4.075C16.4 3.89167 16.6208 3.75 16.8625 3.65C17.1042 3.55 17.3583 3.5 17.625 3.5C17.8917 3.5 18.15 3.55 18.4 3.65C18.65 3.75 18.8667 3.9 19.05 4.1L20.425 5.5C20.625 5.68333 20.7708 5.9 20.8625 6.15C20.9542 6.4 21 6.65 21 6.9C21 7.16667 20.9542 7.42083 20.8625 7.6625C20.7708 7.90417 20.625 8.125 20.425 8.325L7.825 20.925C7.64167 21.1083 7.42917 21.25 7.1875 21.35C6.94583 21.45 6.69167 21.5 6.425 21.5H4ZM15.475 9.025L14.775 8.3L16.2 9.725L15.475 9.025Z" fill="#686868"/>
                      </g>
                    </svg>              
                  </span>
                  <span className='btn-titulo d-none d-md-inline'>
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <mask id="mask0_351_13916" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                      <rect y="0.5" width="24" height="24" fill="#D9D9D9"/>
                      </mask>
                      <g mask="url(#mask0_351_13916)">
                      <path d="M16 5.5V12.5L17.7 14.2C17.8 14.3 17.875 14.4125 17.925 14.5375C17.975 14.6625 18 14.7917 18 14.925V15.5C18 15.7833 17.9042 16.0208 17.7125 16.2125C17.5208 16.4042 17.2833 16.5 17 16.5H13V22.35C13 22.6333 12.9042 22.8708 12.7125 23.0625C12.5208 23.2542 12.2833 23.35 12 23.35C11.7167 23.35 11.4792 23.2542 11.2875 23.0625C11.0958 22.8708 11 22.6333 11 22.35V16.5H7C6.71667 16.5 6.47917 16.4042 6.2875 16.2125C6.09583 16.0208 6 15.7833 6 15.5V14.925C6 14.7917 6.025 14.6625 6.075 14.5375C6.125 14.4125 6.2 14.3 6.3 14.2L8 12.5V5.5C7.71667 5.5 7.47917 5.40417 7.2875 5.2125C7.09583 5.02083 7 4.78333 7 4.5C7 4.21667 7.09583 3.97917 7.2875 3.7875C7.47917 3.59583 7.71667 3.5 8 3.5H16C16.2833 3.5 16.5208 3.59583 16.7125 3.7875C16.9042 3.97917 17 4.21667 17 4.5C17 4.78333 16.9042 5.02083 16.7125 5.2125C16.5208 5.40417 16.2833 5.5 16 5.5ZM8.85 14.5H15.15L14 13.35V5.5H10V13.35L8.85 14.5Z" fill="#686868"/>
                      </g>
                    </svg>              
                  </span>
                  <span className='btn-titulo d-none d-md-inline'>
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <mask id="mask0_351_13919" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                      <rect y="0.5" width="24" height="24" fill="#D9D9D9"/>
                      </mask>
                      <g mask="url(#mask0_351_13919)">
                      <path d="M17 22.5C16.1667 22.5 15.4583 22.2083 14.875 21.625C14.2917 21.0417 14 20.3333 14 19.5C14 19.4 14.025 19.1667 14.075 18.8L7.05 14.7C6.78333 14.95 6.475 15.1458 6.125 15.2875C5.775 15.4292 5.4 15.5 5 15.5C4.16667 15.5 3.45833 15.2083 2.875 14.625C2.29167 14.0417 2 13.3333 2 12.5C2 11.6667 2.29167 10.9583 2.875 10.375C3.45833 9.79167 4.16667 9.5 5 9.5C5.4 9.5 5.775 9.57083 6.125 9.7125C6.475 9.85417 6.78333 10.05 7.05 10.3L14.075 6.2C14.0417 6.08333 14.0208 5.97083 14.0125 5.8625C14.0042 5.75417 14 5.63333 14 5.5C14 4.66667 14.2917 3.95833 14.875 3.375C15.4583 2.79167 16.1667 2.5 17 2.5C17.8333 2.5 18.5417 2.79167 19.125 3.375C19.7083 3.95833 20 4.66667 20 5.5C20 6.33333 19.7083 7.04167 19.125 7.625C18.5417 8.20833 17.8333 8.5 17 8.5C16.6 8.5 16.225 8.42917 15.875 8.2875C15.525 8.14583 15.2167 7.95 14.95 7.7L7.925 11.8C7.95833 11.9167 7.97917 12.0292 7.9875 12.1375C7.99583 12.2458 8 12.3667 8 12.5C8 12.6333 7.99583 12.7542 7.9875 12.8625C7.97917 12.9708 7.95833 13.0833 7.925 13.2L14.95 17.3C15.2167 17.05 15.525 16.8542 15.875 16.7125C16.225 16.5708 16.6 16.5 17 16.5C17.8333 16.5 18.5417 16.7917 19.125 17.375C19.7083 17.9583 20 18.6667 20 19.5C20 20.3333 19.7083 21.0417 19.125 21.625C18.5417 22.2083 17.8333 22.5 17 22.5ZM17 20.5C17.2833 20.5 17.5208 20.4042 17.7125 20.2125C17.9042 20.0208 18 19.7833 18 19.5C18 19.2167 17.9042 18.9792 17.7125 18.7875C17.5208 18.5958 17.2833 18.5 17 18.5C16.7167 18.5 16.4792 18.5958 16.2875 18.7875C16.0958 18.9792 16 19.2167 16 19.5C16 19.7833 16.0958 20.0208 16.2875 20.2125C16.4792 20.4042 16.7167 20.5 17 20.5ZM5 13.5C5.28333 13.5 5.52083 13.4042 5.7125 13.2125C5.90417 13.0208 6 12.7833 6 12.5C6 12.2167 5.90417 11.9792 5.7125 11.7875C5.52083 11.5958 5.28333 11.5 5 11.5C4.71667 11.5 4.47917 11.5958 4.2875 11.7875C4.09583 11.9792 4 12.2167 4 12.5C4 12.7833 4.09583 13.0208 4.2875 13.2125C4.47917 13.4042 4.71667 13.5 5 13.5ZM17 6.5C17.2833 6.5 17.5208 6.40417 17.7125 6.2125C17.9042 6.02083 18 5.78333 18 5.5C18 5.21667 17.9042 4.97917 17.7125 4.7875C17.5208 4.59583 17.2833 4.5 17 4.5C16.7167 4.5 16.4792 4.59583 16.2875 4.7875C16.0958 4.97917 16 5.21667 16 5.5C16 5.78333 16.0958 6.02083 16.2875 6.2125C16.4792 6.40417 16.7167 6.5 17 6.5Z" fill="#686868"/>
                      </g>
                    </svg>              
                  </span>
                  <span className='btn-titulo d-none d-md-inline'>
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <mask id="mask0_351_13922" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                      <rect y="0.5" width="24" height="24" fill="#D9D9D9"/>
                      </mask>
                      <g mask="url(#mask0_351_13922)">
                      <path d="M7 21.5C6.45 21.5 5.97917 21.3042 5.5875 20.9125C5.19583 20.5208 5 20.05 5 19.5V6.5C4.71667 6.5 4.47917 6.40417 4.2875 6.2125C4.09583 6.02083 4 5.78333 4 5.5C4 5.21667 4.09583 4.97917 4.2875 4.7875C4.47917 4.59583 4.71667 4.5 5 4.5H9C9 4.21667 9.09583 3.97917 9.2875 3.7875C9.47917 3.59583 9.71667 3.5 10 3.5H14C14.2833 3.5 14.5208 3.59583 14.7125 3.7875C14.9042 3.97917 15 4.21667 15 4.5H19C19.2833 4.5 19.5208 4.59583 19.7125 4.7875C19.9042 4.97917 20 5.21667 20 5.5C20 5.78333 19.9042 6.02083 19.7125 6.2125C19.5208 6.40417 19.2833 6.5 19 6.5V19.5C19 20.05 18.8042 20.5208 18.4125 20.9125C18.0208 21.3042 17.55 21.5 17 21.5H7ZM17 6.5H7V19.5H17V6.5ZM10 17.5C10.2833 17.5 10.5208 17.4042 10.7125 17.2125C10.9042 17.0208 11 16.7833 11 16.5V9.5C11 9.21667 10.9042 8.97917 10.7125 8.7875C10.5208 8.59583 10.2833 8.5 10 8.5C9.71667 8.5 9.47917 8.59583 9.2875 8.7875C9.09583 8.97917 9 9.21667 9 9.5V16.5C9 16.7833 9.09583 17.0208 9.2875 17.2125C9.47917 17.4042 9.71667 17.5 10 17.5ZM14 17.5C14.2833 17.5 14.5208 17.4042 14.7125 17.2125C14.9042 17.0208 15 16.7833 15 16.5V9.5C15 9.21667 14.9042 8.97917 14.7125 8.7875C14.5208 8.59583 14.2833 8.5 14 8.5C13.7167 8.5 13.4792 8.59583 13.2875 8.7875C13.0958 8.97917 13 9.21667 13 9.5V16.5C13 16.7833 13.0958 17.0208 13.2875 17.2125C13.4792 17.4042 13.7167 17.5 14 17.5Z" fill="#B54141"/>
                      </g>
                    </svg>
                  </span>                  
                </div>
                <div className='d-block d-md-none'>
                  <span className="chat-title" title={titulo}>{titulo}</span>
                  <span className='btn-titulo'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <mask id="mask0_236_5533" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                      <rect width="24" height="24" fill="#D9D9D9"/>
                      </mask>
                      <g mask="url(#mask0_236_5533)">
                      <path d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z" fill="#686868"/>
                      </g>
                    </svg>
                  </span> 
                </div>
              </div>
              </>
            )}
            </Col>
            <Col xs={12} md={4} lg={4} xl={3} 
              className="d-flex justify-content-end d-none d-md-block text-end"
              style={{
                width:'200px'
              }}
            >
              {
                !AutenticationService.getRegistered()&&<>
                  <Button className="btn-upgrade p-0 px-2 mb-2" onClick={navigateTo} >
                  <svg className="me-1" width="18" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_724_3545)">
                    <path d="M20.5668 5.7207H6.17578V19.1286H20.5668V5.7207Z" fill="white"/>
                    <path d="M12.4777 0C5.86312 0 0.5 5.36312 0.5 11.9777C0.5 18.5922 5.86312 23.9554 12.4777 23.9554C13.4608 23.9554 14.8911 23.9554 16.4553 23.9554L6.6229 14.1229V9.8324H10.3324V6.07822H14.6229L24.4554 15.9106C24.4554 14.3464 24.4554 12.9162 24.4554 11.933C24.5 5.36312 19.1368 0 12.4777 0Z" fill="#FDAE01"/>
                    <path d="M14.6675 9.83231H18.377V14.1228H14.6228V17.877H10.3323V14.1228H6.57812L16.4105 23.9552C20.12 23.9552 24.4552 23.9552 24.4552 23.9552C24.4552 23.9552 24.4552 19.62 24.4552 15.9105L14.6228 6.07812V9.83231H14.6675Z" fill="#E5A324"/>
                    <path d="M20.4074 14.7689V9.31641H4.63086V14.7689H20.4074Z" fill="white"/>
                    <path d="M9.75 19.927H15.2026V4.15039H9.75V19.927Z" fill="white"/>
                  </g>        
                  </svg>
                  Mejorar plan
                </Button>
                </>
              }
              

              {/*<FloatingButton2 letter={'A'} menuItems={['Acerca de',"FAQ's",'Politica privacidad']} />*/}
              <FloatingButton
                containerClass="user-info-container2"
                buttonClass="floating-button2"
                menuClass="floating-menu2"
                textClass="user-texts2"
                showUserTextsInMenu={true} // Textos dentro del menú
              />
            </Col>
          
        
      </Row>
      
      <Row        
        style={{
          flexGrow: 1,
          overflowY: 'auto',
        }}
      >
        <Col
          className='d-none d-md-block p-0'
          style={{
            maxWidth: '160px',
            width: '100%',
            flexShrink: 0,
            margin: '0 auto',
          }}
        >
          {messages.length>0 && (
            <div
              className="addUnit vertical"
              style={{                
                maxWidth: '160px',
                width: '100%',
                height: '600px',                
                /*position:'absolute'*/
              }}
            >
              {/*
                <p>Ad</p>
                <p>160x600</p>
              */}
              <AdUnitComponent
                data={responsive_article_vertical_1.data}                
                containerId={'ad-homeVertilcal1'}
              />             
            </div>
          )}
        </Col>

        <Col
          style={{
            flexGrow: 1,
            overflowY: 'auto',
          }}
          className={messages?.length>0?'':'d-flex align-items-center'}
        >
          <div
            ref={chatContainerRef}           
            className="chat-body-messages"
            style={{
              overflowY: 'auto',
              borderRadius: '8px',              
              margin:'0 auto '
            }}
          >
            
            { messages.length==0 ? (
              <MensajePrincipal nombre={nombreUsusario} 
                noticias={noticiasHoy}
                handleChange={handleChange}
                mensajeInicial={mensajeInicial}
              />
            ) : (
              messages.map((msg, index) => (
                <div className={msg?.isUser?'user':'bot'} key={index}>
                  {!msg?.isUser?<>
                    <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.4006 3.84245C14.4456 3.71953 14.5273 3.61342 14.6346 3.53844C14.7419 3.46347 14.8697 3.42327 15.0006 3.42327C15.1315 3.42327 15.2593 3.46347 15.3666 3.53844C15.4739 3.61342 15.5556 3.71953 15.6006 3.84245L16.2106 5.51045C16.69 6.81816 17.4485 8.00575 18.4334 8.99063C19.4183 9.9755 20.6059 10.734 21.9136 11.2135L23.5816 11.8235C23.7045 11.8685 23.8106 11.9502 23.8856 12.0575C23.9606 12.1648 24.0008 12.2925 24.0008 12.4235C24.0008 12.5544 23.9606 12.6821 23.8856 12.7894C23.8106 12.8967 23.7045 12.9784 23.5816 13.0235L21.9136 13.6335C20.6059 14.1129 19.4183 14.8714 18.4334 15.8563C17.4485 16.8412 16.69 18.0287 16.2106 19.3365L15.6006 21.0044C15.5556 21.1274 15.4739 21.2335 15.3666 21.3085C15.2593 21.3834 15.1315 21.4236 15.0006 21.4236C14.8697 21.4236 14.7419 21.3834 14.6346 21.3085C14.5273 21.2335 14.4456 21.1274 14.4006 21.0044L13.7906 19.3365C13.3112 18.0287 12.5526 16.8412 11.5678 15.8563C10.5829 14.8714 9.39531 14.1129 8.0876 13.6335L6.4196 13.0235C6.29668 12.9784 6.19056 12.8967 6.11559 12.7894C6.04062 12.6821 6.00042 12.5544 6.00042 12.4235C6.00042 12.2925 6.04062 12.1648 6.11559 12.0575C6.19056 11.9502 6.29668 11.8685 6.4196 11.8235L8.0876 11.2135C9.39531 10.734 10.5829 9.9755 11.5678 8.99063C12.5526 8.00575 13.3112 6.81816 13.7906 5.51045L14.4006 3.84245ZM4.2006 0.633449C4.22333 0.572209 4.26426 0.519392 4.31789 0.482094C4.37152 0.444796 4.43528 0.424805 4.5006 0.424805C4.56592 0.424805 4.62968 0.444796 4.68331 0.482094C4.73694 0.519392 4.77787 0.572209 4.8006 0.633449L5.1056 1.46645C5.3456 2.12028 5.72501 2.71405 6.21751 3.20654C6.71 3.69903 7.30377 4.07845 7.9576 4.31845L8.7906 4.62345C8.85184 4.64618 8.90466 4.68711 8.94195 4.74074C8.97925 4.79437 8.99924 4.85813 8.99924 4.92345C8.99924 4.98877 8.97925 5.05253 8.94195 5.10616C8.90466 5.15979 8.85184 5.20072 8.7906 5.22345L7.9576 5.52845C7.30377 5.76845 6.71 6.14787 6.21751 6.64036C5.72501 7.13285 5.3456 7.72662 5.1056 8.38045L4.8006 9.21345C4.77787 9.27469 4.73694 9.32751 4.68331 9.36481C4.62968 9.40211 4.56592 9.4221 4.5006 9.4221C4.43528 9.4221 4.37152 9.40211 4.31789 9.36481C4.26426 9.32751 4.22333 9.27469 4.2006 9.21345L3.9006 8.38045C3.6606 7.72662 3.28119 7.13285 2.78869 6.64036C2.2962 6.14787 1.69743 5.76845 1.0486 5.52845L0.215599 5.22345C0.149357 5.20072 0.0965403 5.15979 0.0642441 5.10616C0.0269462 5.05253 0.00195312 4.98877 0.00195312 4.92345C0.00195312 4.85813 0.0269462 4.79437 0.0642441 4.74074C0.101542 4.68711 0.154359 4.64618 0.215599 4.62345L1.0486 4.31845C1.70243 4.07845 2.2962 3.69903 2.78869 3.20654C3.28119 2.71405 3.6606 2.12028 3.9006 1.46645L4.2006 0.633449Z" fill="url(#paint0_linear_724_4485)"/>
                    <defs>
                    <linearGradient id="paint0_linear_724_4485" x1="0.00195313" y1="0.424805" x2="24.5676" y2="1.11023" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FDAE01"/>
                    <stop offset="1" stopColor="#00639B"/>
                    </linearGradient>
                    </defs>
                    </svg>
                    </>
                    :
                    <></>
                    }
                    
                    {msg?.isStructured ? (
                      <BotResponseComponent response={msg.texto} />
                    ) : (
                      <span dangerouslySetInnerHTML={{ __html: markdownToHtml(convertTextToHtmlWithLinks(msg?.texto)) }}></span>
                    )}
                    
                    {!msg?.isUser&&<>
                    <div className='ms-2 mt-3'>
                      <span className='btn-chat' title='Copiar' 
                        onClick={()=>(copiar(typeof msg?.texto === 'string' ? msg?.texto : JSON.stringify(msg?.texto)))}
                      >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <mask id="mask0_724_4523" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                          <rect width="20" height="20" fill="#D9D9D9"/>
                          </mask>
                          <g mask="url(#mask0_724_4523)">
                          <path d="M7.5 15.0003C7.04167 15.0003 6.64931 14.8371 6.32292 14.5107C5.99653 14.1844 5.83333 13.792 5.83333 13.3337V3.33366C5.83333 2.87533 5.99653 2.48296 6.32292 2.15658C6.64931 1.83019 7.04167 1.66699 7.5 1.66699H15C15.4583 1.66699 15.8507 1.83019 16.1771 2.15658C16.5035 2.48296 16.6667 2.87533 16.6667 3.33366V13.3337C16.6667 13.792 16.5035 14.1844 16.1771 14.5107C15.8507 14.8371 15.4583 15.0003 15 15.0003H7.5ZM7.5 13.3337H15V3.33366H7.5V13.3337ZM4.16667 18.3337C3.70833 18.3337 3.31597 18.1705 2.98958 17.8441C2.66319 17.5177 2.5 17.1253 2.5 16.667V5.00033H4.16667V16.667H13.3333V18.3337H4.16667Z" fill="#686868"/>
                          </g>
                        </svg>
                      </span>
                      <span className='btn-chat' title='Me gusta'>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_724_4526" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                        <rect width="20" height="20" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_724_4526)">
                        <path d="M15.0013 17.4997H5.83464V6.66634L11.668 0.833008L12.7096 1.87467C12.8069 1.9719 12.8867 2.10384 12.9492 2.27051C13.0117 2.43717 13.043 2.5969 13.043 2.74967V3.04134L12.1263 6.66634H17.5013C17.9457 6.66634 18.3346 6.83301 18.668 7.16634C19.0013 7.49967 19.168 7.88856 19.168 8.33301V9.99967C19.168 10.0969 19.1541 10.2011 19.1263 10.3122C19.0985 10.4233 19.0707 10.5275 19.043 10.6247L16.543 16.4997C16.418 16.7775 16.2096 17.0136 15.918 17.208C15.6263 17.4025 15.3207 17.4997 15.0013 17.4997ZM7.5013 15.833H15.0013L17.5013 9.99967V8.33301H10.0013L11.1263 3.74967L7.5013 7.37467V15.833ZM5.83464 6.66634V8.33301H3.33464V15.833H5.83464V17.4997H1.66797V6.66634H5.83464Z" fill="#686868"/>
                        </g>
                        </svg>
                      </span>
                      <span className='btn-chat' title='No me gusta'>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <mask id="mask0_724_4529" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                          <rect width="20" height="20" fill="#D9D9D9"/>
                          </mask>
                          <g mask="url(#mask0_724_4529)">
                          <path d="M4.9987 2.5H14.1654V13.3333L8.33203 19.1667L7.29036 18.125C7.19314 18.0278 7.11328 17.8958 7.05078 17.7292C6.98828 17.5625 6.95703 17.4028 6.95703 17.25V16.9583L7.8737 13.3333H2.4987C2.05425 13.3333 1.66536 13.1667 1.33203 12.8333C0.998698 12.5 0.832031 12.1111 0.832031 11.6667V10C0.832031 9.90278 0.84592 9.79861 0.873698 9.6875C0.901476 9.57639 0.929253 9.47222 0.957031 9.375L3.45703 3.5C3.58203 3.22222 3.79036 2.98611 4.08203 2.79167C4.3737 2.59722 4.67925 2.5 4.9987 2.5ZM12.4987 4.16667H4.9987L2.4987 10V11.6667H9.9987L8.8737 16.25L12.4987 12.625V4.16667ZM14.1654 13.3333V11.6667H16.6654V4.16667H14.1654V2.5H18.332V13.3333H14.1654Z" fill="#686868"/>
                          </g>
                        </svg>
                      </span>
                    </div>
                    </>}         
                  </div>
              ))
            )}
            {messages.length>0&&loading&&<Spinner animation='border' size='sm' />}
          </div>
        </Col>

        <Col
          className='d-none d-md-block p-0'
          style={{
            maxWidth: '160px',
            width: '100%',
            flexShrink: 0,
            margin: '0 auto',
          }}
        >
          {messages.length>0 && (
            <div              
              className="addUnit vertical"
              style={{              
                maxWidth: '160px',
                width: '100%',
                height: '600px',                
                /*zIndex:'-1'*/
              }}
            >
              {/*
                <p>Ad</p>
                <p>160x600</p>
              */}
              <AdUnitComponent
                data={responsive_article_vertical_1.data}                
                containerId={'ad-homeVertilcal2'}
              /> 
            </div>
          )}
        </Col>
      </Row>

      
      <Row className="d-block d-md-none" style={{ flexShrink: 0 }}>
        <Col>          
          {messages.length>0 && (
            <div              
              className="addUnit horizontal mobile"
              style={{                
                maxWidth: '320px',
                width: '100%',
                height: '50px',
              }}
            >
              {/*<p>Ad 320x50</p>*/}
              <AdUnitComponent
                  data={responsive_article_sticky.data}                  
                  containerId={'ad-horizontalMobile2'}
                /> 
            </div>
          )}
        </Col>
      </Row>
      
      <Row className="py-2" style={{ flexShrink: 0 }}>
        <Col className='prompt-box-main'>
          <div className={(loading?"disable":'') +" prompt-box d-flex justify-content-center mb-3"} style={{userSelect:'none'}}>
              <FormControl
                as="textarea"
                rows={1}
                value={inputValue}
                onChange={handleInputChange}
                onKeyDown={(e)=> (e.key === 'Enter'&&handleSendMessage())}
                placeholder={loading?'Espera un momento...':"¿Qué quieres descubrir hoy?"}
                disabled={loading}
                ref={inputRef}
                className='textConversal'
              />
              {/*<CustomSelect items={['Creactivo','Balanceado','Objetivo']} disabled={loading}  />*/}
              <Button 
                className="btn-send " 
                onClick={handleSendMessage}
                disabled={loading}
              >
                {!loading&&<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.8 8.92522L1.4 15.4252C1.06667 15.5585 0.75 15.5294 0.45 15.3377C0.15 15.146 0 14.8669 0 14.5002V1.50022C0 1.13355 0.15 0.854382 0.45 0.662715C0.75 0.471049 1.06667 0.441882 1.4 0.575215L16.8 7.07522C17.2167 7.25855 17.425 7.56688 17.425 8.00022C17.425 8.43355 17.2167 8.74188 16.8 8.92522ZM2 13.0002L13.85 8.00022L2 3.00022V6.50022L8 8.00022L2 9.50022V13.0002Z" fill="white"/>
                </svg>
                }
                {loading&&<div className='px-1'><Spinner animation='border' size='sm' /></div>}
              </Button>
          </div>   
        </Col>
      </Row>

      <Row className="d-none d-md-block" style={{ flexShrink: 0 }} >
        <Col>
          {messages.length==0 && (            
            <div
              className="addUnit horizontal"
              style={{
                maxWidth:'970px',
                width:'100%',                
                height:'250px',                
                }}
              >
              {/*
              <p>Ad</p>
              <p>970x250</p>
              */}
              <AdUnitComponent
                data={responsive_article_leaderboard_1.data}
                containerId={'ad-homeDestop'}
              />             
            </div>            
          )}          
        </Col>        
      </Row>
      <Row className="d-block d-md-none" style={{ flexShrink: 0 }}>
        <Col>
          {messages.length==0 && (
            <div 
              className="addUnit horizontal mobile"
              style={{                 
                maxWidth:'320px',
                width:'100%',                
                height:'100px'                
                }}
              >
              {/*
                <p>Ad</p>
                <p>320x100</p>                            
              */}
              <AdUnitComponent
                data={responsive_article_leaderboard_2.data}                
                containerId={'ad-homeMobile'}
              />             
              
            </div>
          )}          
        </Col>        
      </Row>
    </Container>    
    <Toaster 
      position="bottom-center"
      reverseOrder={false}
    />
    </>
  );
};

const MensajePrincipal = ({nombre,noticias,handleChange,mensajeInicial}) => {
  const [saludo, setSaludo] = useState('');

  useEffect(() => {
    const horaActual = new Date().getHours();

    if (horaActual >= 6 && horaActual < 12) {
      setSaludo('¡Buenos días');
    } else if (horaActual >= 12 && horaActual < 20) {
      setSaludo('¡Buenas tardes');
    } else {
      setSaludo('¡Buenas noches');
    }    
  }, []);

  const seleccionarTema = (tema) =>{
    handleChange({texto:tema,isUser:true});    
  }
  return(<>
    <div       
      className='chat-bienvenida text-center'
    >
      <span className='titulo login-titulo display-5 text-center fw-semibold lh-sm'>{saludo}{nombre&&' '+nombre}!</span>
      <div className='my-2'>&nbsp;</div>
      <span className='titulo fs-5 text-center fw-semibold lh-sm'>{mensajeInicial}</span>
      <ul className='mt-3'>
        {/*noticias.map((item,index)=>(
          <li key={index} onClick={()=>seleccionarTema(item)} className='b-rotate'><span>{item}</span></li>
        ))*/}
      </ul>
    </div>
  </>);
}

const CustomSelect = ({ items, disabled }) => {
  const [selected, setSelected] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const options = items;

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
  };

  return (
    <div className="custom-select-container">
      <div
        className="custom-selected-option"
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        <span className="selected-text">{selected ? selected : 'Cambiar tono'}</span>
        <svg className={`arrow-icon ${isOpen ? 'rotate-180' : ''}`} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.39949 5.63353L11.2995 0.733529C11.4662 0.566862 11.6606 0.486306 11.8828 0.491862C12.105 0.497418 12.2995 0.583529 12.4662 0.750195C12.6328 0.916862 12.7162 1.11131 12.7162 1.33353C12.7162 1.55575 12.6328 1.7502 12.4662 1.91686L7.34949 7.0502C7.21616 7.18353 7.06616 7.28353 6.89949 7.3502C6.73282 7.41686 6.56616 7.4502 6.39949 7.4502C6.23282 7.4502 6.06616 7.41686 5.89949 7.3502C5.73282 7.28353 5.58282 7.18353 5.44949 7.0502L0.316154 1.91686C0.149488 1.7502 0.0689321 1.55297 0.0744876 1.3252C0.0800432 1.09742 0.166154 0.900195 0.332821 0.733529C0.499488 0.566862 0.693932 0.483529 0.916154 0.483529C1.13838 0.483529 1.33282 0.566862 1.49949 0.733529L6.39949 5.63353Z" fill="rgba(0, 99, 155, 1)"/>
        </svg>
      </div>

      {isOpen && (
        <div className="custom-options-container">
          {options.map((option, index) => (
            <div
              key={index}
              className={"custom-option "+ (selected === option?'selected':'')}
              onClick={() => handleSelect(option)}
            >
              {selected === option && (
                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg" className="check-icon">
                  <path d="M10.0972 0.617776C10.0973 0.61771 10.0973 0.617645 10.0974 0.61758C10.2629 0.443457 10.4645 0.35 10.6961 0.35C10.9278 0.35 11.1298 0.443434 11.2965 0.61733C11.4631 0.791271 11.55 0.999348 11.55 1.23528C11.55 1.4696 11.4668 1.67541 11.3041 1.84524L10.0972 0.617776ZM10.0972 0.617776L4.44741 6.51434L2.30314 4.27642C2.14011 4.1014 1.93889 4.00829 1.70624 4.00829C1.47333 4.00829 1.27044 4.10144 1.10354 4.27562C0.937051 4.44939 0.85 4.65687 0.85 4.89196C0.85 5.12705 0.937051 5.33453 1.10354 5.5083L3.85762 8.38267C4.02424 8.55657 4.22627 8.65 4.458 8.65C4.68963 8.65 4.89118 8.55653 5.05674 8.38237C5.05679 8.38232 5.05683 8.38227 5.05688 8.38222L11.304 1.84538L10.0972 0.617776Z" fill="url(#paint0_linear_351_11490)" stroke="url(#paint1_linear_351_11490)" strokeWidth="0.3"/>
                  <defs>
                    <linearGradient id="paint0_linear_351_11490" x1="1" y1="0.5" x2="11.6432" y2="0.837796" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#00767A"/>
                      <stop offset="1" stopColor="#00639B"/>
                    </linearGradient>
                    <linearGradient id="paint1_linear_351_11490" x1="1" y1="0.5" x2="11.6432" y2="0.837796" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#00767A"/>
                      <stop offset="1" stopColor="#00639B"/>
                    </linearGradient>
                  </defs>
                </svg>
              )}
              <span className="option-text">{option}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


export default ChatComponent;
